import type { ConceptDef } from '../types';

export const tactAnimals: ConceptDef = {
  kind: 'supervisorScored',
  id: 'tact-animals',
  label: 'Expressive Animals',
  category: 'Expressive',
  description: 'Show an animal; learner names it. Supervisor scores.',
  config: {
    promptMode: 'TEXT',
    prompts: [
      { prompt: '🐘 elephant' },
      { prompt: '🦒 giraffe' },
      { prompt: '🐶 dog' },
      { prompt: '🐱 cat' },
      { prompt: '🐮 cow' },
      { prompt: '🐑 sheep' },
      { prompt: '🐦 bird' },
      { prompt: '🐟 fish' },
    ],
  },
};
